import { PolicyFlowClosing } from 'src/types'

export const initialValues = {} as PolicyFlowClosing

export const defaultValue = {
  active: true,
  automatic_closing: false,
  code: '',
  consensual_closing: false,
  cost_center_closing: false,
  description: '',
  name: '',
  policy_closing_id: 'new'
} as PolicyFlowClosing
